import React from 'react';

const Donation = () => {
  return (
    <div className="container mt-5">
      <h3>This is a donation page</h3>
       
    </div>
  );
};

export default Donation;